// extracted by mini-css-extract-plugin
export default {"printRoot":"Print_printRoot__OTHno","receiptPage":"Print_receiptPage__jsuH0","line":"Print_line__YNPJe"};